import React from "react";

const CreditCancellation = () => {
  return <div>PENDIENTE</div>;
};

export default CreditCancellation;
